import { z } from 'zod';

export const RewardTypeSchema = z.enum(['payment_based', 'activity_based']);
export type RewardType = z.infer<typeof RewardTypeSchema>;

export const ReferralCodeResponseSchema = z.object({
  referral_code: z.string(),
  successful_referral_count: z.number(),
  reward_type: RewardTypeSchema.nullable().optional(),
});

export const ApplyReferralCodeRequestSchema = z.object({
  referral_code: z.string(),
});

export const ApplyReferralCodeResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  reward_type: RewardTypeSchema.nullable().optional(),
});

export const ReferredUserSchema = z.object({
  email: z.string(),
  name: z.string().nullable(),
  status: z.enum(['pending', 'successful']),
  referred_at: z.string(),
  completed_at: z.string().nullable(),
  credit_earned_cents: z.number().nullable(),
  reward_type: RewardTypeSchema.nullable().optional(),
  qualifying_days_completed: z.number().default(0),
});

export const ReferralStatsResponseSchema = z.object({
  total_credits_earned_cents: z.number(),
  referred_users: z.array(ReferredUserSchema),
  referrer_reward_type: RewardTypeSchema.nullable().optional(),
});

export const InviteResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
});

export interface InviteRequest {
  emails: string[];
}

export type InviteResponse = z.infer<typeof InviteResponseSchema>;

export type ReferralCodeResponse = z.infer<typeof ReferralCodeResponseSchema>;
export type ApplyReferralCodeRequest = z.infer<
  typeof ApplyReferralCodeRequestSchema
>;
export type ApplyReferralCodeResponse = z.infer<
  typeof ApplyReferralCodeResponseSchema
>;
export type ReferredUser = z.infer<typeof ReferredUserSchema>;
export type ReferralStatsResponse = z.infer<typeof ReferralStatsResponseSchema>;
